import React, {useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider, useDispatch } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { PersistGate } from 'redux-persist/integration/react';
// import { IntlProvider } from 'react-intl';
import { store, persistor } from './redux/store';
import { useTheme } from './assets/styles/theme';
// import i18n from './localization/i18n';
import { MessageTip } from './components/messageTip';
import './assets/styles/animation.css';
import MainRouter from './route/MainRouter';
import { supabase } from './redux/supabase';
import { setUserInfo } from './redux/slice/AuthSlice';
import './assets/styles/main.css';

// ReactGA.initialize(TRACKING_ID);
function App() {
  const theme = useTheme();
  const dispatch = useDispatch();

  useEffect(()=>{
    supabase.auth.onAuthStateChange((event, session) => {
      if(session && session.user && !session.user.is_anonymous){
        dispatch(setUserInfo(session.user))
      }else{
        dispatch(setUserInfo(null))
      }
    });
  })
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <IntlProvider
        messages={i18n.getMessages(lang)}
        key={lang}
        locale={lang}
        defaultLocale={i18n.getDefaultLocale()}
      > */}
        {/* <GoogleOAuthProvider clientId="676781562441-khp1bkcdo47oo6u7dlfml1qu3jldqcpf.apps.googleusercontent.com"> */}
          <MessageTip />
          <MainRouter />
        {/* </GoogleOAuthProvider> */}
      {/* </IntlProvider> */}
    </ThemeProvider>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <ReduxProvider store={store}>
      <PersistGate persistor={persistor} loading={<></>}> {/*  */}
        <App />
      </PersistGate>
    </ReduxProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
